import React from "react";
import { useQueryParams } from "shared/@hooks/useQueryParams";
import { Tab, TabContainer } from "shared/TabContainer";
import DownlineTree from "./DownlineTree";
import styles from "./index.module.css";
import Upline from "./Upline";
import Report from "./Report";

/**
 * A map of names to query param values.
 */
export const tabs = {
  diamondship: "diamondship",
  emeraldship: "emeraldship",
  platinumship: "platinumship",
  downlineTree: "downlinetree",
  downlinePins: "downlinepins",
  upline: "upline",
};

const pinMap = {
  diamond: 4,
  emerald: 3,
  platinum: 2,
  "associate ibo": 1,
};

export default function LOS({ iboInfo, iboNumber }) {
  const query = useQueryParams();

  const pinLevel = pinMap[iboInfo.lineOfSponsorship.pinLevel.toLowerCase()];

  const selectedTab = query.get("los-tab") ?? tabs.upline;

  return (
    <TabContainer
      className={styles.container}
      value={selectedTab}
      onTabChange={(value) => {
        query.set({ "los-tab": value });
      }}
    >
      <Tab title="Upline" value={tabs.upline}>
        <Upline iboNumber={iboNumber} />
      </Tab>

      <Tab title="Downline Tree" value={tabs.downlineTree}>
        <DownlineTree iboNumber={iboNumber} />
      </Tab>

      {/* 
  {iboInfo.pinLevel > 1 && (
    <Tab title="Downline Pins" value={tabs.downlinePins}>
      <header>
        <h3>
          Downline Pins of <FormattedName value={iboInfo.fullName} />
        </h3>
      </header>

      <DownlinePins
        tab={tab}
        iboNumber={iboNumber}
        isInteractive={true}
        getMemberUrl={getMemberUrl}
      />
    </Tab>
  )} */}

      {pinLevel > 3 && (
        <Tab title="Diamondship" value={tabs.diamondship}>
          <Report
            url={`/v1/membership/los/downlineship/${iboNumber}/4`}
            queryKey="dship"
          />
        </Tab>
      )}

      {pinLevel > 2 && (
        <Tab title="Emeraldship" value={tabs.emeraldship}>
          <Report
            url={`v1/membership/los/downlineship/${iboNumber}/3`}
            queryKey="eship"
          />
        </Tab>
      )}

      {pinLevel > 1 && (
        <Tab title="Platinumship" value={tabs.platinumship}>
          <Report
            url={`/v1/membership/los/downlineship/${iboNumber}/2`}
            queryKey="pship"
          />
        </Tab>
      )}
    </TabContainer>
  );
}
